const ExclamationMarkIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M72 0H8C3.58172 0 0 3.58171 0 7.99999V72.0002C0 76.4184 3.58172 80.0002 8 80.0002H72C76.4183 80.0002 80 76.4184 80 72.0002V8C80 3.58172 76.4183 0 72 0Z"
      fill="#F4EFED"
    />
    <mask
      id="mask0_8461_6070"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <path
        d="M72 0H8C3.58172 0 0 3.58171 0 7.99999V72.0002C0 76.4184 3.58172 80.0002 8 80.0002H72C76.4183 80.0002 80 76.4184 80 72.0002V8C80 3.58172 76.4183 0 72 0Z"
        fill="#FB6E44"
      />
    </mask>
    <g mask="url(#mask0_8461_6070)">
      <path
        d="M40.0001 -10.167L-12 79.9998H92.0002L40.0001 -10.167Z"
        fill="#0A0777"
      />
    </g>
    <path
      d="M40.0002 72.0004C44.7867 72.0004 48.6669 68.1202 48.6669 63.3337C48.6669 58.5472 44.7867 54.667 40.0002 54.667C35.2137 54.667 31.3335 58.5472 31.3335 63.3337C31.3335 68.1202 35.2137 72.0004 40.0002 72.0004Z"
      fill="#FB6E44"
    />
    <path d="M45.6667 24H34V52.0001H45.6667V40V24Z" fill="white" />
  </svg>
);

export default ExclamationMarkIcon;
